<template>
    <div class="project-images">
        <div class="project-images__field" v-for="(value,index) in projectImages" :key="value.Key">
            <FileUpload @fileChange="handleFileUploadChange" :name="getInputFieldName(`${fieldName}[${index}].File`)"
                acceptTypes="image/jpeg,image/jpg" :sizeLimit="3000000" />
            <InputText :name="getInputFieldName(`${fieldName}[${index}].AltText`)" aria-label="Indtast alt-tekst for billede" placeholder="Indtast alt-tekst for billede" v-model="projectImages[index].Text" />
            <Button class="p-button-secondary" @click="() => { projectImages.splice(index, 1); }"
                aria-label="Fjern fil" icon="pi pi-times" rounded></Button>
        </div>
        <Button  class="project-images__add-button p-button-secondary" v-if="projectImages.length < 5" @click="() => { projectImages.push({Text:'',Key:Date.now()}); }" 
            aria-label="Tilføj projektbillede" rounded icon="pi pi-plus"></Button>
    </div>
</template>
<script>
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import FileUpload from './fileUpload.vue';
export default {
    name: "projectImagesUpload",
    props: ['getInputFieldNameMethod','fieldName'],
    components: {
        Button,
        InputText,
        FileUpload
    },
    data() {
        return {
            projectImages:[] //Contains an entry for each image, not the image itself. Used to modify the input field name.
        };
    },
    methods: {
        handleFileUploadChange(validationResult) {
            this.$emit("fileChange", validationResult);
        },
        getInputFieldName(name) {
            if(typeof this.getInputFieldNameMethod !== 'undefined') {
                return this.getInputFieldNameMethod(name)
            }else {
                return name;
            }
        }
    }
};
</script>